angular.module('app.filters').filter(
    'money',
    () => (amount) =>
        Math.round(amount)
            .toString()
            .replace(/(\d)(?=(\d{3})+$)/g, '$1 ')
);
